// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"MenuButton_highlighted__1hcXL","normal":"MenuButton_normal__qsETn","menuButton":"MenuButton_menuButton__3UILM"};